import { useState, type FormEvent } from 'react'

type Status = 'idle' | 'sending' | 'done'

/** Shared state and submit handler for the newsletter sign-up forms (sent to Mailchimp by the server). */
export function useNewsletterSignup() {
  const [status, setStatus] = useState<Status>('idle')
  const [error, setError] = useState('')

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const form = new FormData(event.currentTarget)
    const email = String(form.get('email') || '').trim()
    if (!email || status === 'sending') return
    setStatus('sending')
    setError('')
    try {
      const res = await fetch('/api/public/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          name: String(form.get('name') || '').trim(),
          website: String(form.get('website') || ''),
        }),
      })
      const data = (await res.json().catch(() => null)) as { error?: string } | null
      if (!res.ok) throw new Error(data?.error || 'Could not sign you up right now.')
      setStatus('done')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign you up right now.')
      setStatus('idle')
    }
  }

  return { done: status === 'done', sending: status === 'sending', error, onSubmit }
}
